import { Observable, distinctUntilChanged, map, merge, skip, take } from "rxjs";
import { debounceTime } from "rxjs";

export const debounceAfterFirstEmission = <T>(delay: number) => {
  return (source: Observable<T>) => merge(source.pipe(take(1)), source.pipe(skip(1), debounceTime(delay)));
};

export const distinctUntilArrayFieldChanged = <T extends object[], K extends keyof T[number]>(field: K) => {
  return (source: Observable<T>) =>
    source.pipe(
      map((a) => a.map((z) => ({ ...z }) as T[number])), // deep copy necessary to avoid reference equality
      distinctUntilChanged(
        (a, b) => JSON.stringify(a.map((z) => z[field])) === JSON.stringify(b.map((z) => z[field])),
      ),
    );
};
